module.exports = __webpack_public_path__ + "static/image3-abeba8d1a64604e508c41e42746e6cd9.png";